import styled from "styled-components"
import { motion } from "framer-motion"

export const DashboardContainer = styled(motion.div)`
  min-height: 100vh;
  background: #1E1F23;
  color: white;
`

export const Header = styled(motion.header)`
  padding: 24px;
  background: #2A2B2E;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const Title = styled(motion.h1)`
  font-size: 28px;
  font-weight: 600;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

export const ContentArea = styled(motion.main)`
  padding: 20px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`

